import React, { useState } from 'react';
import LoginModal from './LoginModal';
import { useAccountContext } from '../context/AccountContext';

/**
 * Test component for LoginModal - demonstrates functionality
 */
export default function TestLoginModal() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const accountContext = useAccountContext();

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleLoginSuccess = (userData) => {
        console.log('Login successful:', userData);
        // Handle successful login - modal will close automatically
    };

    return (
        <div className="p-8">
            <div className="max-w-md mx-auto bg-dark-blue/30 rounded-xl p-6">
                <h1 className="text-white text-2xl font-bold mb-4">LoginModal Test</h1>

                <div className="mb-4">
                    <p className="text-white">
                        Login Status: {accountContext.loggedIn ? 'Logged In' : 'Not Logged In'}
                    </p>
                    {accountContext.loggedIn && (
                        <p className="text-gray-300 text-sm">
                            Account: {accountContext.account?.emailAddress}
                        </p>
                    )}
                </div>

                <button
                    onClick={handleOpenModal}
                    className="w-full px-4 py-2 bg-yellow text-dark-blue font-bold rounded-lg hover:bg-yellow/90 transition-colors"
                >
                    Test Login Modal
                </button>

                <div className="mt-4 text-sm text-gray-300">
                    <p>This button simulates the scenario where a user tries to generate without being logged in.</p>
                </div>
            </div>

            <LoginModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                onLoginSuccess={handleLoginSuccess}
            />
        </div>
    );
}